"use client";
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"; // Removed Navigation
import "swiper/css";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

 
interface Testimonial {
  id: number;
  clientName: string;
  clientFeedback: string;
  linkDyna: string;
  clientIcon?: StaticImageData;
}

// Define the Props interface
interface ServicesSectionProps {
  title?: string;
  subtitle?: string;
  testimonials: Testimonial[];
  swiperBreakpoints?: Record<number, { slidesPerView: number }>;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({
  title = "Our Top Services",
  subtitle = "Discover the pinnacle of excellence with our range of premier services.",
  testimonials,
 
}) => {
  const [items] = useState<Testimonial[]>(testimonials);

  return (
    <section className="mt-0 pt-0">
      <div className="container">
        <h1 className="fw-bolder display-5 text-center textHad">{title}</h1>
        <p className="fw-normal fs-5 text-center">{subtitle}</p>
        <div className="row g-4 mt-2">
          <Swiper
            className="mt-4 px-4"
            modules={[Autoplay]} // Removed Navigation module
            spaceBetween={30}
            slidesPerView={1}
            autoplay={{
              delay: 5000,
            }} 
                        breakpoints={{
              576: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
          >
            {items.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="text-center hvr-float testBord">
                  <Image
                    src={item.clientIcon!}
                    className="img-fluid mb-3 mt-4"
                    alt={`Client ${item.clientName}`}
                    width={150}
                    height={150}
                  />
                  <h4 className="fw-bold fs-5 my-2">{item.clientName}</h4>
                  <p className="textPara fs-6">{item.clientFeedback}</p>
                  <Link href={item.linkDyna} className="custBg rounded-circle">
                    <FontAwesomeIcon icon={faArrowRight} className="my-3" />
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
